import React from 'react'
import "./TextField.css";

const TextField = ({ label, infoKey = "", name, value, nameField = false, nameValues, setCallback }) => {
    return (
        <div className='row my-1 d-flex justify-content-start'>
            <div className='col-12 col-sm-6 col-md-6'>
                <p className='text-primary fw-bold field'>
                    {label}
                </p>
            </div>

            {!nameField &&
                <div className='col-12 col-sm-6 col-md-6 inputField'>
                    <input
                        className="col-12 col-sm-11 text-md address-form-control"
                        type="text"
                        name={`${infoKey?infoKey+"_":""}${name}`}
                        value={value}
                        onChange={(e) => setCallback(name, e.target.value, infoKey)}
                    />
                </div>
            }

            {nameField &&
                <div className='col-12 row'>
                    <div className='col-5 col-sm-5 col-md-6 fields'>
                        <input
                            className="col-12 text-md address-form-control"
                            type="text"
                            name={`${infoKey?infoKey+"_":""}firstName`}
                            value={nameValues?.firstName}
                            placeholder={"First Name"}
                            onChange={(e) => setCallback("firstName", e.target.value, infoKey)}
                        />
                    </div>
                    <div className='col-2 col-sm-2 col-md-2'>
                        <input
                            className="col-12 text-md address-form-control middleInit"
                            type="text"
                            maxLength={1}
                            name={`${infoKey?infoKey+"_":""}middleInitial`}
                            value={nameValues?.middleInitial}
                            placeholder={"MI"}
                            onChange={(e) => setCallback("middleInitial", e.target.value, infoKey)}
                        />
                    </div>
                    <div className='col-5 col-sm-5 col-md-4 fields-right'>
                        <input
                            className="col-12 text-sm address-form-control"
                            type="text"
                            name={`${infoKey?infoKey+"_":""}lastName`}
                            value={nameValues?.lastName}
                            placeholder={"Last Name"}
                            onChange={(e) => setCallback("lastName", e.target.value, infoKey)}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

export default TextField